
import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import ouDetail from "./components/OuDetail.vue";
import ouEdit from "./components/ou_edit.vue";
import UserSelect from "@/components/UserSelect/index.vue";
import DepartmentSelect from "@/components/DepartmentSelect/index.vue";
import api from "@/api";
import {
  OrganizationUnitDto,
  OrganizationUnitLevel,
  UserDto,
  DepartmentDto
} from "@/api/appService";

@Component({
  name: "userManager",
  components: { ouDetail, ouEdit, UserSelect, DepartmentSelect }
})
export default class UserManager extends Vue {
  @Ref() userSelect!: UserSelect;
  @Ref() departmentSelect!: DepartmentSelect;
  @Ref() editDialog!: ouEdit;

  level: any[] = [];

  selectOU: OrganizationUnitDto = { id: 0 };
  detail: any = {};
  dialogShow = false;
  editShow = false;

  tableData: any = {
    selection: [],
    items: [],
    pagesize: 5,
    page: 1,
    sorting: "id asc",
    totalCount: 0
  };
  tableData2: any = {
    selection: [],
    items: [],
    pagesize: 10,
    page: 1,
    sorting: "uou.id desc",
    totalCount: 0
  };
  treeData: any[] = [];
  form_ou: any = {
    title: "添加机构",
    show: false,
    data: {
      displayName: "",
      parentId: undefined,
      detail: {
        logoImgUrl: "",
        desc: "",
        businessLicenseUrl: "",
        idCardBackUrl: "",
        idCardFrontUrl: ""
      }
    }
  };
  form_user: any = {
    title: "添加成员",
    show: false,
    data: {},
    rules: {}
  };
  created() {
    this.fetchData();
  }

  // 取得机构用户
  async fetchOUUsers() {
    await api.organizationUnit
      .getOrganizationUnitUsers({
        id: this.selectOU!.id,
        sorting: this.tableData2.sorting,
        maxResultCount: this.tableData2.pagesize,
        skipCount: (this.tableData2.page - 1) * this.tableData2.pagesize
      })
      .then((response: any) => {
        this.tableData2.items = response.items;
        this.tableData2.totalCount = response.totalCount;
      });
  }

  fetchUsers() {
    api.user
      .getAll({
        keyword: this.form_user.keyword,
        sorting: this.tableData.sorting,
        skipCount: (this.tableData.page - 1) * this.tableData.pagesize,
        maxResultCount: this.tableData.pagesize
      })
      .then((response: any) => {
        this.tableData.items = response.items;
        this.tableData.totalCount = response.totalCount;
      });
  }

  async fetchData() {
    await api.organizationUnit.getCurrent().then(async res => {
      this.selectOU = res;
      await this.fetchOUUsers();
    });
  }

  async handleView_ou() {
    await api.organizationUnit
      .getOrganizationUnit({ id: this.selectOU!.id })
      .then(res => {
        (this.$refs.detailDialog as any).show = true;
        this.detail = res;
      });
  }

  async handleEdit_ou() {
    await api.organizationUnit
      .getForEdit({ id: this.selectOU!.id })
      .then(res => {
        (this.$refs.editDialog as any).show = true;
        this.detail = res.data;
        this.detail.isCurrent = true;
        this.level = (res.schema as any).level;
        // this.form_ou.show = true;
        // this.form_ou.data = res;
        // this.form_ou.title = `编辑机构 ${this.form_ou.data.displayName}`;
      });
  }

  async handleDelete_ou_user() {
    const userIds: number[] = [];
    const organizationUnitId = this.selectOU!.id;
    await this.$confirm("您确认要删除此用户吗?", "删除提示").then(
      () => {
        this.tableData2.selection.forEach((x: any) => {
          userIds.push(x.id as number);
        });
        api.organizationUnit
          .removeUsersFromOrganizationUnit({
            body: { userIds, organizationUnitId }
          })
          .then(res => {
            this.fetchOUUsers();
          });
      },
      cancel => {
        console.log("cancel delete ou user");
      }
    );
  }
  // handle_user start

  dep() {
    this.departmentSelect.show = true;
  }

  onDepartmentSelect(dep: DepartmentDto) {
    console.log(dep);
    if (this.selectOU!.id) {
      api.organizationUnit
        .addUsersToOrganizationUnit({
          body: {
            userIds: this.users.map(x => x.id!),
            organizationUnitId: this.selectOU!.id as number,
            departmentId: dep.id
          }
        })
        .then(res => {
          console.log(res);
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.form_user.show = false;
          this.users = [];
          this.fetchOUUsers();
          this.fetchData();
        });
    }
  }

  handleAdd_user() {
    this.userSelect.show = true;
  }

  users: UserDto[] = [];

  onSelect(e: UserDto[]) {
    this.users = e;
    this.departmentSelect.show = true;
  }
  // handle_user end

  handleSelectionChange2(e: any) {
    // 机构用户选中
    console.log(e);
    this.tableData2.selection = e;
  }
  sort(e: any) {
    console.log("sort : ", e);
    if (e.prop === "userName") e.prop = `user.UserName`;
    if (e.prop === "id") e.prop = `uou.id`;
    if (e.prop === "phoneNumber") e.prop = `user.PhoneNumber`;
    if (e.prop && e.order) {
      this.tableData2.sorting = `${e.prop} ${e.order}`;
    } else {
      this.tableData2.sorting = "uou.id desc";
    }
    this.fetchOUUsers();
  }

  // user table
  current_change(e: any) {
    this.tableData.page = e;
    this.fetchUsers();
  }
  handleSizeChange(e: any) {
    this.tableData.pagesize = e;
    this.fetchUsers();
  }
}
